(function() {
  if (window.__gkikzAtcReady) return;
  window.__gkikzAtcReady = true;

  // The floating cart snippet is rendered ONLY when the theme's Cart type = Drawer
  // (settings.cart_action == 'overlay'). So we use its presence as the mode signal:
  //   floating cart present  -> Drawer mode -> intercept add-to-cart and open the floating cart.
  //   floating cart absent   -> Page mode   -> do nothing; the native add-to-cart goes to /cart.
  function floatingCart() { return document.querySelector('[data-gkfc]'); }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || form.action || '';
    if (!/\/cart\/add/i.test(action)) return;
    if (!floatingCart()) return; // Page mode: let the form submit through to the /cart page

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);
    var submitBtns = form.querySelectorAll('[type="submit"]:not([disabled])');
    submitBtns.forEach(function(b) { b.disabled = true; });

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw err; });
      return r.json();
    })
    .then(function() {
      submitBtns.forEach(function(b) { b.disabled = false; });
      if (window.gkfcOpen) { window.gkfcOpen(); } else { window.location.href = '/cart'; }
    })
    .catch(function(err) {
      submitBtns.forEach(function(b) { b.disabled = false; });
      console.error('GKIKZ ATC error:', err);
      if (err && err.description) {
        var msg = document.createElement('div');
        msg.textContent = err.description;
        msg.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#D43A3A;color:#fff;padding:12px 20px;border-radius:6px;z-index:99999;font-size:13px;';
        document.body.appendChild(msg);
        setTimeout(function() { msg.remove(); }, 4000);
      }
    });
  }, true);

  // Third-party /cart/add.js fetch (apps, bundle widgets) -> open floating cart, Drawer mode only.
  if (window.fetch && !window.__gkikzFetchWrapped) {
    window.__gkikzFetchWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/i.test(urlStr)) {
        promise.then(function(r) {
          if (r && r.ok && floatingCart() && window.gkfcOpen) {
            setTimeout(function(){ window.gkfcOpen(); }, 250);
          }
        }).catch(function() {});
      }
      return promise;
    };
  }

  // Third-party /cart/add.js XHR (apps still using XMLHttpRequest) -> open floating cart, Drawer mode only.
  if (window.XMLHttpRequest && !window.__gkikzXhrWrapped) {
    window.__gkikzXhrWrapped = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__gkikzUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      if (xhr.__gkikzUrl && /\/cart\/add(\.js)?(\?|$)/i.test(xhr.__gkikzUrl)) {
        xhr.addEventListener('load', function() {
          if (xhr.status >= 200 && xhr.status < 300 && floatingCart() && window.gkfcOpen) {
            setTimeout(function(){ window.gkfcOpen(); }, 250);
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
